import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Flex, Icon } from '../../../common/styles/global_styles'

export interface AddLookupButtonProps {
    label: string
    onClick?: () => void
    disabled?: boolean
    editMode: boolean
}

const AddLookupButton = ({ label, onClick, disabled = false, editMode }: AddLookupButtonProps): ReactElement => {
    return (
        <AddLookupButtonStyles editMode={editMode} disabled={disabled} onClick={onClick}>
            <Flex direction={'row'} justifyContent={'center'} fillParent={false}>
                <Icon className={'fas fa-plus-circle add_icon'} />
                <label className={'label_button'}>{label}</label>
            </Flex>
        </AddLookupButtonStyles>
    )
}

export default AddLookupButton

interface ButtonProps {
    editMode: boolean
}
export const AddLookupButtonStyles = styled.button<ButtonProps>`
    visibility: ${props => (!props.editMode ? 'hidden' : 'visible')};
    width: 100%;
    height: 38px;
    margin: 0%;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    border: 1px solid ${({ theme }) => theme['gray-500']};
    border-top: none;
    box-sizing: border-box;

    background-color: ${({ theme }) => theme['gray-0']} !important;

    transition-duration: 0.4s;
    cursor: pointer;

    .label_button {
        color: ${props => (props.editMode ? props.theme['blue-500'] : props.theme['gray-1000'])};
        font-family: ${({ theme }) => theme['font-semibold']};
        font-size: 13px;
        cursor: pointer;
    }

    &:hover {
        cursor: pointer;
        .label_button,
        .add_icon {
            color: ${props => (props.editMode ? props.theme['blue-400'] : props.theme['gray-700'])};
            cursor: pointer;
        }
    }

    .add_icon {
        color: ${props => (props.editMode ? props.theme['blue-500'] : props.theme['gray-1000'])};
        font-size: 13px;
        padding-right: 8.5px;
        margin-top: 1px;
        vertical-align: middle;
        cursor: pointer;
    }
`
